/**
 * @module @ui5/flexibility-utils
 * @public
 */

module.exports = {
	/**
	 * @public
	 * @see module:@ui5/flexibility-utils/src/changeUtils.js
	 */
	change: require("./src/changeUtils")
};